import React from 'react'

export const SberIcon = () => (
	<svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
		<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F0F0F0" />
		<g clipPath="url(#clip0_5386_7106)">
			<rect x="7" y="7" width="18" height="18" rx="9" fill="white" />
			<path
				d="M16.3214 7H15.6786C10.8855 7 7 11.0294 7 16C7 20.9706 10.8855 25 15.6786 25H16.3214C21.1145 25 25 20.9706 25 16C25 11.0294 21.1145 7 16.3214 7Z"
				fill="url(#paint0_radial_5386_7106)"
			/>
			<path
				d="M20.5785 12.4613C20.8533 12.8166 21.086 13.2027 21.2718 13.6117L16.0014 17.4968L13.7988 16.116V14.4549L16.0014 15.8357L20.5785 12.4613Z"
				fill="white"
			/>
			<path
				d="M11.5505 15.9995C11.5505 15.925 11.5523 15.8509 11.556 15.7773L10.2211 15.7119C10.2166 15.8073 10.2139 15.9037 10.2139 16.0009C10.2133 16.7605 10.3627 17.5127 10.6535 18.2144C10.9443 18.9161 11.3708 19.5535 11.9086 20.09L12.8554 19.1436C12.4415 18.7313 12.1131 18.2413 11.8892 17.7018C11.6653 17.1622 11.5502 16.5837 11.5505 15.9995Z"
				fill="white"
			/>
			<path
				d="M16.0005 11.5513C16.075 11.5513 16.1491 11.554 16.2227 11.5576L16.2895 10.2223C16.1937 10.2178 16.0974 10.2155 16.0005 10.2155C15.2406 10.2146 14.4879 10.3638 13.7859 10.6545C13.0837 10.9453 12.446 11.3718 11.9092 11.9097L12.856 12.8566C13.2683 12.4425 13.7583 12.1141 14.298 11.89C14.8376 11.666 15.4162 11.5509 16.0005 11.5513Z"
				fill="white"
			/>
			<path
				d="M16.0004 20.4495C15.9258 20.4495 15.8517 20.4495 15.7777 20.4437L15.7109 21.7785C15.8069 21.7833 15.9034 21.7858 16.0004 21.7858C16.76 21.7866 17.5122 21.6373 18.214 21.3465C18.9156 21.0556 19.553 20.629 20.0894 20.0911L19.1444 19.1447C18.732 19.5585 18.2421 19.8868 17.7025 20.1107C17.163 20.3347 16.5845 20.4499 16.0004 20.4495Z"
				fill="white"
			/>
			<path
				d="M18.5089 12.3271L19.6338 11.4979C18.6056 10.6653 17.3221 10.212 15.999 10.2144V11.5506C16.895 11.5495 17.7701 11.8202 18.5089 12.3271Z"
				fill="white"
			/>
			<path
				d="M21.7854 16.0005C21.7861 15.6529 21.7557 15.3059 21.6945 14.9637L20.4491 15.8815C20.4491 15.921 20.4491 15.9605 20.4491 16.0005C20.4494 16.6222 20.3191 17.237 20.0667 17.8051C19.8142 18.3731 19.4451 18.8818 18.9834 19.2981L19.8817 20.2909C20.4818 19.7491 20.9615 19.0871 21.2895 18.3481C21.6174 17.6089 21.7863 16.8091 21.7854 16.0005Z"
				fill="white"
			/>
			<path
				d="M16.0003 20.4498C15.3786 20.45 14.7637 20.3196 14.1956 20.0671C13.6275 19.8147 13.1187 19.4457 12.7022 18.9841L11.71 19.8819C12.2517 20.4821 12.9136 20.9619 13.6528 21.2899C14.3919 21.6179 15.1916 21.7869 16.0003 21.786V20.4498Z"
				fill="white"
			/>
			<path
				d="M13.0162 12.7019L12.1185 11.7091C11.5181 12.2509 11.0383 12.9128 10.7102 13.6519C10.3821 14.391 10.213 15.1909 10.2139 15.9995H11.5505C11.5503 15.3779 11.6806 14.7631 11.9331 14.195C12.1856 13.6269 12.5546 13.1182 13.0162 12.7019Z"
				fill="white"
			/>
		</g>
		<defs>
			<radialGradient
				id="paint0_radial_5386_7106"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(37.8571 5.39286) rotate(154.107) scale(36.8018 36.8018)">
				<stop stopColor="#21A038" />
				<stop offset="0.464814" stopColor="#0197F6" />
				<stop offset="1" stopColor="#F2E913" />
			</radialGradient>
			<clipPath id="clip0_5386_7106">
				<rect x="7" y="7" width="18" height="18" rx="9" fill="white" />
			</clipPath>
		</defs>
	</svg>
)
